import React from "react";
import { ToastContainer } from "react-toastify";
import { useUserTheme } from "src/shared/utils/useUserTheme";

interface SearchFieldProps {
  searchTerm: string;
  handleSearch: (value: string) => void;
}

const SearchField: React.FC<SearchFieldProps> = ({ searchTerm, handleSearch }) => {
  const { fontClass, borderHighlight } = useUserTheme();

  return (
    <div className={`w-full min-w-0 ${fontClass}`}>
      <input
        type="text"
        name="order-search"
        value={searchTerm}
        onChange={(e) => handleSearch(e.target.value)}
        placeholder="Search Order ID, Phone, Name, Bill No..."
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} placeholder-gray-400 text-sm text-black bg-white h-10`}
      />

      <ToastContainer />
    </div>
  );
};

export default SearchField;
